/**
 * Centralized form-related message constants
 */

export const FORM_MESSAGES = {
  DISCARD_CHANGES_TITLE: '編集内容の破棄',
  DISCARD_CHANGES_CONFIRMATION:
    '編集した内容が保存されていません。編集内容を破棄してもよろしいですか？',
  CONFIRM_OK: 'OK',
  CONFIRM_CANCEL: 'キャンセル',
} as const;
